import { Box, MenuItem, Select } from "@mui/material";
import { useState } from "react";
import { useStyles } from "../styles";

const CustomSelectTag = ({
  handleChangeTee,
  playerInfo,
  teesList,
  playerNo,
  disable,
}) => {
  const classes = useStyles();

  const handleChange = (e) => {
    const selectedTee = teesList.filter(
      (val) => val.tee_color == e.target.value
    );
    handleChangeTee(selectedTee[0], playerNo);
  };

  return (
    <Box
      className={classes.textBoxMain}
      sx={{
        backgroundColor:
          playerInfo.tee_color == "yellow"
            ? "#FFC700"
            : playerInfo.tee_color == "blue"
            ? "#0C2DD8"
            : playerInfo.tee_color == "black"
            ? "#000000"
            : "#C4C4C4",
      }}
    >
      <Box className={classes.numberBox}>{playerInfo.handicap_value}</Box>
      <Select
        variant="standard"
        disableUnderline
        disabled={disable}
        value={playerInfo.tee_color}
        onChange={handleChange}
        sx={{
          fontSize: { md: "11px", xl: "13px" },
          padding: 0,
          // paddingLeft: 0.2,
          color: "#fff",
          fontWeight: 700,
          letterSpacing: ".25px",
          margin: "0 auto",
          width: "100%",
          textTransform: 'capitalize',
          "::before": { display: "none" },
          ":focus": { backgroundColor: "transparent !important" },
          ":focus-within": { background: "transparent !important" },
        }}
      >
        {teesList &&
          teesList.map((tee) => (
            <MenuItem key={tee._id} value={tee.tee_color}>
              {tee.tee_color}
            </MenuItem>
          ))}
      </Select>
    </Box>
  );
};

export default CustomSelectTag;
